import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './state';
import storeTable from './modules/storeTable';
import user from './modules/user';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    storeTable,
    user
  },
};

export default new Vuex.Store<RootState>(store);
